// /src/AppWrapper.jsx

import React, { useMemo } from "react";
import { RouterProvider } from "react-router-dom";

import { useAuth } from "./authContext";
import { createRouter } from "./router";
import { useStatus } from "./StatusContext";
import { useSecurity } from "./SecurityContext";

function RouterWithContext() {
  const { isLoggedIn, setIsLoggedIn, setEmail } = useAuth();
  const { isSuperAdmin } = useSecurity();

  const status = useStatus();
  const networkStatus = status?.networkStatus ?? "online";
  const serverStatus = status?.serverStatus ?? "ok";

  const maintenanceActive =
    networkStatus === "offline"
    || serverStatus === "unreachable"
    || (status?.maintenance === true && !isSuperAdmin);

  const router = useMemo(
    () => createRouter({
      isLoggedIn,
      isUnderMaintenance: () => maintenanceActive,
      setIsLoggedIn,
      setEmail,
    }),
    [isLoggedIn, maintenanceActive, setIsLoggedIn, setEmail, isSuperAdmin],
  );

  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    />
  );
}

export default function AppWrapper() {
  return <RouterWithContext />;
}
